import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Labels } from 'Helpers';
import Icon from 'Components/Icon';

/**
 * Language Selector
 *
 * Shows available languages and
 * selected language from user.
 */

class LanguageSelector extends PureComponent {
    constructor() {
        super();

        this.state = { isOpen: false };
        this.optionsRef = React.createRef();
        this.triggerRef = React.createRef();

        this.onChange = this.onChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    /**
     * The component receives information about the clicks and if it was outside of the
     * OccupancySelector or in the trigger then the selector is closed in case it is open
     */
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick);
    }

    onChange(newLanguage) {
        const { onChangeLanguage, currentLanguage } = this.props;
        if (newLanguage !== currentLanguage) {
            onChangeLanguage(newLanguage);
        }

        this.setState({ isOpen: false });
    }

    /**
     * The method reacts to the caller by considering whether the caller is inside the component
     */
    handleClick(e) {
        const { isOpen } = this.state;
        const [ options, trigger ] = [ this.optionsRef && this.optionsRef.current, this.triggerRef && this.triggerRef.current ];

        if (!isOpen && trigger.contains(e.target)) {
            this.setState({ isOpen: true });
        } else if (isOpen && (trigger.contains(e.target) || !options.contains(e.target))) {
            this.setState({ isOpen: false });
        }
    }

    render() {
        const { defaultLanguage, currentLanguage, availableLanguages, hidden } = this.props;

        const { isOpen } = this.state;

        const languages = Labels.getLanguages();

        const defaultLanguageOption = {
            key       : defaultLanguage,
            value     : defaultLanguage,
            text      : languages[`language_${defaultLanguage}`],
            onClick   : () => this.onChange(defaultLanguage),
            className : (defaultLanguage === currentLanguage) ? 'kbe-active' : '',
        };

        const languageOptions = [];
        availableLanguages.filter(language => language !== currentLanguage).forEach((languageCode) => {
            languageOptions.push({
                key       : languageCode,
                value     : languageCode,
                text      : languages[`language_${languageCode}`],
                onClick   : () => this.onChange(languageCode),
                className : (languageCode === currentLanguage) ? 'kbe-active' : '',
            });
        });

        return (
            <div className={`kbe-dropdown kbe-dropdown-right kbe-language-dropdown ${hidden ? 'kbe-hidden' : ''}`}>
                <div className={`kbe-flex kbe-flex-middle kbe-dropdown-click ${isOpen ? 'kbe-active' : ''}`} ref={this.triggerRef}>
                    <span>{currentLanguage.toUpperCase()}</span>
                    <Icon name="CaretDown" className="kbe-margin-left-small" fill="rgba(255, 255, 255, .9)" size="10" />
                </div>
                { isOpen ? <div className="kbe-dropdown-menu" ref={this.optionsRef}>
                    <ul>
                        <li {...defaultLanguageOption}>{defaultLanguageOption.text}</li>
                        {languageOptions.length > 0 && <li className="kbe-divider" />}
                        {languageOptions.map(option => <li key={option.key} {...option}>{option.text}</li>)}
                    </ul>
                </div> : null}
            </div>
        );
    }
}

LanguageSelector.defaultProps = { hidden: false };

LanguageSelector.propTypes = {
    defaultLanguage    : PropTypes.string.isRequired,
    currentLanguage    : PropTypes.string.isRequired,
    availableLanguages : PropTypes.arrayOf(PropTypes.string).isRequired,
    onChangeLanguage   : PropTypes.func.isRequired,
    hidden             : PropTypes.bool,
};

export default LanguageSelector;
